<template>
    <div class="cat_conter" :id="'option'+idx">
        <div class="conter_top">
            <div class="testpaper-question-tit-wrap">
                <div class="testpaper-question-tit">{{idx+1}}</div>
                <div class="testpaper-question-score">{{parentData.topic_score}}.0分</div>
            </div>
            <div class="testpaper-question-topic clearfix">
                <div v-html="strcharacterDiscode(parentData.topic_stem)"></div>
                <br />
            </div>
        </div>
        <div class="testpaper-question-choices">
            <textarea class="textarea" style="min-height: 33px;height: 40px;"
            placeholder="请输入内容"  @blur="subjectiveData(parentData.topic_id,idx)" ref="subjectiveText">
            </textarea>
        </div>
    </div>
</template>

<script>
    import strcharacterDiscode from '@/js/strcharacterDiscode'
    export default {
        props:['parentData','idx'],
        data(){
            return {
                selectIndex: []
            }
        },
        created() {
            
        },
        methods: {
            subjectiveData(key,idx) {
                
                this.$emit('subjectiveData',[this.$refs.subjectiveText.value,key])
                if(this.$refs.subjectiveText.value.length>0){
                    document.querySelector("#card"+idx).className="active";
                }else{
                    document.querySelector("#card"+idx).className="";
                }
                
            },
            strcharacterDiscode
        }
    }
</script>

<style scoped>
    .testpaper-question-tit-wrap{
        float: left;
        margin-right: 10px;
    }
    .testpaper-question-tit-wrap{
        text-align: center;
    }
    .testpaper-question-tit{
        font-size: 20px;
        color: #3a87ad;
    }
    .testpaper-question-score {
        font-size: 12px;
        color: #aaa;
        border: 1px solid #ccc;
        padding: 0 1px;
        border-radius: 5px;
        background: #f6f6f6;
        display: inline-block;
    }
    .testpaper-question-topic {
        border-bottom: 1px dashed #ddd;
        margin-bottom: 10px;
        overflow: hidden;
        zoom: 1;
    }
    .active{
        background: rgb(105, 153, 117);
        color: #fff;
    }
    .testpaper-question-choices{
        padding-left: 36px;
        padding-top: 5px;
    }
    .textarea{
        display: block;
        resize: vertical;
        padding: 5px 15px;
        line-height: 1.5;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 100%;
        font-size: inherit;
        color: #606266;
        background-color: #FFF;
        background-image: none;
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    }
</style>


    


// WEBPACK FOOTER //
// src/components/Subjective.vue